import React from 'react';
import ChipList from '@components-clean/core/chip-list';

interface IProps {
    isDisabled: boolean;
}

const ChipListPage = ({ isDisabled }: IProps) => {
    return (
        <>
            <fieldset>
                <legend>Primary</legend>

                <ChipList
                    data-testid="chip-list"
                    disabled={isDisabled}
                    defaultData={[
                        {
                            text: 'All',
                            value: 1,
                        },
                        {
                            text: 'Reviewed',
                            value: 2,
                        },
                        {
                            text: 'Unreviewed',
                            value: 3,
                        },
                    ]}
                />
            </fieldset>

            <br />

            <fieldset>
                <legend>Secondary</legend>

                <ChipList
                    data-testid="chip-list-scondary"
                    disabled={isDisabled}
                    secondary
                    defaultData={[
                        {
                            text: 'All',
                            value: 1,
                        },
                        {
                            text: 'Reviewed',
                            value: 2,
                        },
                        {
                            text: 'Unreviewed',
                            value: 3,
                        },
                    ]}
                />
            </fieldset>

            <br />

            <fieldset>
                <legend>Inactive (only with selection=&quot;none&quot;)</legend>

                <ChipList
                    data-testid="chip-list-scondary"
                    disabled={isDisabled}
                    selection="none"
                    activeField="active"
                    defaultData={[
                        {
                            text: 'Active 1',
                            value: 1,
                            active: true,
                        },
                        {
                            text: 'Inactive 1',
                            value: 2,
                            active: false,
                        },
                        {
                            text: 'Inactive 2',
                            value: 3,
                            active: false,
                        },
                        {
                            text: 'Active 2',
                            value: 4,
                            active: true,
                        },
                        {
                            text: 'Active 3',
                            value: 5,
                            active: true,
                        },
                    ]}
                />
            </fieldset>
        </>
    );
};

export default ChipListPage;
